
import { defineComponent, ref, onUnmounted, onMounted } from 'vue'

export default defineComponent({
  props: {
    active: {
      type: Boolean,
      require: true
    },
    closeOnBackgroundClick: {
      type: Boolean,
      default: false
    },
    background: {
      type: Boolean,
      require: true
    },
    minWidth: {
      type: String,
      require: true
    }
  },
  setup(props, { emit }) {
    const modalBodyRef = ref()

    function handler(event: MouseEvent) {
      const target = event.target as HTMLElement
      if (modalBodyRef?.value?.contains(target)) return
      if (
        !modalBodyRef?.value?.contains(target) &&
        props.closeOnBackgroundClick
      ) {
        emit('close-modal')
      }
    }

    onMounted(() => {
      window.addEventListener('click', handler)
    })

    onUnmounted(() => {
      window.removeEventListener('click', handler)
    })

    return { modalBodyRef }
  }
})
